import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=2d9cc304&scoped=true"
import script from "./AppMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=2d9cc304&prod&lang=scss&scoped=true"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=2d9cc304&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9cc304",
  null
  
)

export default component.exports